import { classes, style } from 'typestyle';
import { TEAL_PRIMARY, smallBreakpoint } from 'src/utils/Style/Theme';

const RIGHT_PAGE_OPTIONS_WIDTH = 150;
const mainContent = style({
  $debugName: 'mainContent',
  width: `100%`,
});

const mainContentPrint = style({
  zoom: 0.8,
});

const pageOptions = style({
  $debugName: 'pageOptions',
  display: 'inline-block',
  width: RIGHT_PAGE_OPTIONS_WIDTH,
  paddingLeft: 20,
});

const basicOption = style({
  $debugName: 'pageOption',
  width: '100%',
  margin: '10px 0',
  cursor: 'pointer',
});

const selectedOption = style({
  borderLeft: `5px solid #289f88`,
  paddingLeft: '5px',
});

const pageOption = (active: boolean) => {
  if (active) {
    return classes(basicOption, selectedOption);
  }
  return basicOption;
};
const exitButton = 'exit-btn far fa-times';
const modalHeader = style({
  width: '100%',
  backgroundColor: TEAL_PRIMARY,
  padding: '1em',
  marginBottom: '1em',
  $nest: {
    h3: {
      fontSize: '1.25em',
      margin: 0,
      color: 'white',
      paddingLeft: '1.25em',
      display: 'inline-block',
    },
    '.exit-btn': {
      float: 'right',
      fontSize: '1.5em',
      color: 'white',
      cursor: 'pointer',
    },
  },
});
const modal = style({
  justifyContent: window.innerWidth > smallBreakpoint ? 'center' : 'inherit',
  display: 'flex',
  alignItems: 'center',
  $nest: {
    '.modal-content-container': {
      width: '90vw',
      height: '98vh',
      backgroundColor: 'white',
      overflowY: 'hidden',
      maxWidth: 1500,
    },
  },
});

export default {
  mainContent,
  pageOptions,
  pageOption,
  modalHeader,
  exitButton,
  mainContentPrint,
  modal,
};
